export default function getAttributionDataById(branchId) {
  // here we extract data from session storage
  // and return branch id specific ddata

  let data = JSON.parse(sessionStorage.getItem("attribution"));

  let outputD = data.filter((item) => {
    if (item.branchId == branchId) return true;
  });
  console.log(outputD);
  if (outputD.length == 1) return outputD[0];
  else return null;
}
